import type { ChangeEvent } from 'react';
import { Box, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { MediaInfoBox } from '../Media/MediaInfoBox';

interface StandardCategoryClipCountSectionProps {
  standardCategoryClipCount: number;
  onStandardCategoryClipCountChange: (count: number) => void;
}

export function StandardCategoryClipCountSection({
  standardCategoryClipCount,
  onStandardCategoryClipCountChange,
}: StandardCategoryClipCountSectionProps) {
  const handleStandardCategoryClipCountChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const nextValue = Number.parseInt(event.target.value, 10);
    onStandardCategoryClipCountChange(Number.isNaN(nextValue) ? 1 : Math.max(1, nextValue));
  };

  return (
    <Stack direction="row" spacing={4} sx={{ p: 3 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
          Standardkategorier
        </Typography>
        <TextField
          label="Antal klipp som visas"
          type="number"
          size="small"
          value={standardCategoryClipCount}
          onChange={handleStandardCategoryClipCountChange}
          inputProps={{ min: 1, step: 1 }}
          InputProps={{
            endAdornment: <InputAdornment position="end">klipp</InputAdornment>,
          }}
          sx={{ maxWidth: 360 }}
        />
      </Box>
      <MediaInfoBox>
        Styr hur många videor som visas i varje standardkategori i Play-sektionen.
      </MediaInfoBox>
    </Stack>
  );
}
